import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { CloudUpIcon } from '../../theme/Icons';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { RecordingState } from './RecordingState';

export interface RecordingRetryButtonProps {
    recordingId: string;
    size?: 'small' | 'default' | 'large';
    fill?: 'clear' | 'outline' | 'solid';
    showLabel?: boolean;
    style?: React.CSSProperties;
    dataId?: string;
}

export const RecordingRetryButton: FC<RecordingRetryButtonProps> = ({
    recordingId,
    size = 'small',
    fill = 'clear',
    showLabel = true,
    style,
    dataId
}) => {
    const recordingState = useInstance(RecordingState);

    const handleRetry = () => {
        recordingState.retryOfflineRecording(recordingId);
    };

    return (
        <IonButton
            fill={fill}
            size={size}
            onClick={handleRetry}
            data-id={dataId || `retry-upload-${recordingId}`}
            color="primary"
            style={style}
        >
            <CloudUpIcon size="small" />
            {showLabel && <span style={{ marginLeft: '4px', fontSize: '12px' }}>Retry</span>}
        </IonButton>
    );
};
